const Button = ({ title, onClick }) => {
  return (
    <button className='btn btn-block' onClick={ onClick }>{ title }</button>
  )
}

export default Button